module.exports = __webpack_public_path__ + "static/img/section-1.644e6cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/section-1.jpg
// module id = rAJn
// module chunks = 0